import {useContext} from 'react';
import {UserContext} from "../../../context/UserContext";
import {ParserDateTime} from "../../../helper/dateFormatHandler";
import {UserBadge} from "#src/helper/userHelper";

const ChatMessage = ({ activityItem }) => {
    const { user } = useContext(UserContext);

    const getCompanyName = () => {
        if(activityItem?.companyname !== ' ' && activityItem?.companyname !== null) {
            return `${activityItem?.companyname}`
        } else {
            return '-';
        }
    }


    if(activityItem?.linkType === "progressUpdate" || activityItem?.linkType === "progressUpdateStageBack") {
        return (
            <div >
                <div className={"text-xs text-center mb-2  mt-2"}>
                    <span className={"text-gray-900 font-bold ml-2"}>Update</span>
                    <span className={"text-gray-600/60 ml-2"}>{ParserDateTime(activityItem?.createdAt)}</span>
                </div>
                <div className={"bg-gray-200 text-xs  block rounded w-full p-4 text-sm "}>
                    <div className={"text-gray-600/60 text-center"}>{activityItem?.message}</div>
                </div>
            </div>
        )
    }  else if( activityItem?.linkType === "tenderMessage") {
        return (
            <div >
                <div className={"flex flex-row-reverse mb-2  mt-8"}>
                    {UserBadge(getCompanyName(),"Auftragnehmer", 8, 'xs')}
                    <div >
                        <div className={"text-xs mb-2 text-right"}>
                            <span className={"text-gray-900 font-bold mr-2"}>{getCompanyName()} ({activityItem?.username})</span>
                            <span className={"text-gray-600/60 block mr-2"}>{ParserDateTime(activityItem?.createdAt)}</span>
                        </div>
                        <div className={"border-gray-300 border   rounded rounded-bl-2xl rounded-tr-none m-2 p-4 text-xs  block ml-6"}>
                            <div className={"text-gray-600/60 "}>{activityItem?.message}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if( activityItem?.linkType === "progressUpdateCompleted" ) {
        return (
            <div >
                <div className={"text-xs text-center mb-2  mt-4 "}>
                    <span className={"text-gray-900 font-bold ml-2"}>Auftrag Absgeschlossen</span>
                    <span className={"text-gray-600/60 ml-2"}>{ParserDateTime(activityItem?.createdAt)}</span>
                </div>
                <div className={"bg-gray-200 text-xs  block rounded w-full p-4 text-sm "}>
                    <div className={"text-gray-600/60 text-center"}>{activityItem?.message}</div>
                </div>
            </div>
        )
    }  else {
        if ( activityItem?.createdByCompany === user.companyId) { 
            return (
                <div >
                    <div className={"flex mb-2 mt-8 justify-end"}>
                        <div className='max-w-full'>
                            <div className={"text-xs mb-2 flex flex-col items-end"}>
                                <span className={"text-gray-900 font-bold mr-2"}>{activityItem?.username} ({getCompanyName()})</span>
                                <span className={"text-gray-600/60 block mr-2"}>{ParserDateTime(activityItem?.createdAt)}</span>
                            </div>
                            <div className={"border-gray-300 border rounded rounded-bl-2xl rounded-tr-none m-2 p-4 text-xs block ml-6"}>
                                <div className={"text-gray-600/80 break-words text-right"}>{activityItem?.message}</div>
                            </div>
                        </div>
                        {UserBadge(activityItem?.username,"Auftragnehmer", 8, 'xs')}
                    </div>
                </div>
            )
        } else {
            return (
                <div >
                    <div className={"flex mb-2 mt-8"}>
                        {UserBadge(activityItem?.username,"Auftragnehmer", 8, 'xs')}
                        <div className='max-w-full'>
                            <div className={"text-xs mb-2  "}>
                                <span className={"text-gray-900 font-bold ml-2"}>{activityItem?.username} ({getCompanyName()})</span>
                                <span className={"text-gray-600/60 block ml-2"}>{ParserDateTime(activityItem?.createdAt)}</span>
                            </div>
                            <div className={"border-gray-300 border rounded rounded-br-2xl rounded-tl-none m-2 p-4 text-xs  block mr-6"}>
                                <div className={"text-gray-600/60 break-words"}>{activityItem?.message}</div>
                            </div>
                        </div>
                    </div>
                </div>
            )
    }
    }


};

export default ChatMessage;
